import RootLayout from "layouts/RootLayout";
import clsx from "clsx";
import {liff} from "@line/liff";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

const LIFF_ID = process.env.REACT_APP_CONSULTING_LIFF_ID;

const initializeLIFF = async () => {
    try {
        await liff.init({liffId: LIFF_ID});
        if (!liff.isLoggedIn()) {
            liff.login();
        }
        console.log('LIFF 初始化成功');
        console.log('LIFF：', liff);
        if (!liff.isInClient()) {
            // 增加發置 discord 通知有被引導到諮詢表單的用戶
            const discordWebhookUrl = process.env.REACT_APP_DISCORD_WEBHOOK_URL;
            if (discordWebhookUrl) {
                const displayName = (await liff.getProfile()).displayName || 'Guest'; // 防止 displayName 为空
                await fetch(discordWebhookUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body: JSON.stringify({
                        content: `LIFF ID: ${LIFF_ID}，有用戶被引導到「諮詢警訊確認」，Line 名稱: ${displayName}，Line ID: ${liff.getContext().userId}`,
                    }),
                });
            }
            window.location.href = `https://line.me/R/app/${LIFF_ID}`;
            // alert('諮詢表單請使用手機 LINE APP 開啟填寫，如您有緊急需求請撥打 119 或可參考下列就醫資訊詢問');
            // window.location.href = "https://klbaby.gocare.tw/clinicList";   // dev
            return liff;
        }
        return liff;
    } catch (error: unknown) {
        console.error('初始化 liff 時出錯：', error);
    }
};

const Consulting = () => {
    const { t } = useTranslation("consult");
    const [liffClientObject, setLiffClientObject] = useState(null);
    const [isYesButtonDisabled, setIsYesButtonDisabled] = useState(false);

    useEffect(() => {
        const initialize = async () => {
            const liffObject = await initializeLIFF();
            console.log('liffObject:', liffObject);
            setLiffClientObject(liffObject);
        };
        initialize()
    }, []);


    // const userId = liffClientObject?.getContext()?.userId
    // const accessToken = liffClientObject?.getAccessToken()

    const sendLiffWarning = async (liffClient: typeof liff) => {
        try {
            setIsYesButtonDisabled(true);

            const profile = await liff.getProfile();
            const displayName = profile.displayName || 'Guest';
            const userId = liff.getContext()?.userId;

            // 發送 Discord 通知 (保留)
            const discordWebhookUrl = process.env.REACT_APP_DISCORD_WEBHOOK_URL;
            if (discordWebhookUrl) {
                await fetch(discordWebhookUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body: JSON.stringify({
                        content: `LIFF ID: ${LIFF_ID}，有用戶「出現警訊表徵」，Line 名稱: ${displayName}，Line ID: ${userId}`,
                    }),
                });
            }

            // 透過 LINE sendMessages 發送關鍵字訊息，觸發後端處理
            await liffClient.sendMessages([
                {
                    type: 'text',
                    text: '有出現警訊表徵'
                }
            ]);

            liffClient.closeWindow();
            setIsYesButtonDisabled(false);
        } catch (error: unknown) {
            setIsYesButtonDisabled(false);
            console.error('Error sending warning message:', error);
            alert(t('warning.alertNetworkError'));
        }
    }
    const handleNo = () => {
        window.location.href = "https://liff.line.me/" + process.env.REACT_APP_FORM_LIFF_ID;
    };

    const handleYes = async () => {
        if (liffClientObject) {
            await sendLiffWarning(liffClientObject);
        } else {
            console.error('LIFF client object is not initialized');
        }
    }

    return (
        <RootLayout title={t("nav.title")}>
            <div className="p-6 flex flex-col justify-center items-center">
                <div className="pb-8 text-xl tracking-wide">
                    {t('warning.question')}
                </div>
                <div className="w-full">
                    <img src="/img/119-title.png" alt={t('warning.imgAlt')} className="pb-8"/>
                    <img src="/img/119.png" alt={t('warning.imgAlt')} className="w-full"/>
                </div>
                <div className="pt-2 w-4/5 flex flex-col justify-center items-center space-y-5 ">
                    <button
                        name="yesButton"
                        className="h-10 w-full bg-[#FF6666] rounded-[20px] text-white" disabled={isYesButtonDisabled}
                        onClick={handleYes}
                    >
                        {isYesButtonDisabled ? t('warning.yesGoMedical') : t('warning.yes')}
                    </button>
                    <button
                        className={clsx(
                            "h-10 w-full bg-[#FCE4EC]",
                            "border-[1px] border-[#FF6666] rounded-[20px]"
                        )}
                        onClick={handleNo}
                    >
                        {t('warning.no')}
                    </button>
                </div>
            </div>
        </RootLayout>
    );
};

export default Consulting;
